import { Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import { setDocumentTitle } from "@/lib/documentTitle";

import { A7FIACompositionsEdit } from "./edit";
import { A7FIACompositionsTable } from "./table";

export default function A7FIACompositions() {
  useEffect(() => {
    setDocumentTitle("Quantilia | FIA Compositions");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<A7FIACompositionsEdit />} />
      <Route index element={<A7FIACompositionsTable />} />
    </Routes>
  );
}
